/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';
	const historynav = () => {
		let scroll = window.scrollY;
		let $headerInner = document.querySelector('.history-nav');
		if (scroll > 0) {
			$headerInner.classList.add('is-scroll')
		} else {
			$headerInner.classList.remove('is-scroll')
		}
		window.addEventListener("scroll", function () {
			scroll = window.scrollY;
			$headerInner = document.querySelector('.history-nav');
			if (scroll > 0) {
				$headerInner.classList.add('is-scroll')
			} else {
				$headerInner.classList.remove('is-scroll')
			}
		});
		// グロナビカレント
		document.querySelectorAll('.history-nav-in-list-item-head').forEach(item1 => {
			if(item1.dataset.category == location.pathname.split('/')[3]) {
				item1.classList.add(a);
			}
		});
		// pc
		document.querySelectorAll('.history-nav-in-list-item').forEach(item1 => {
			if(item1.querySelector('button')) {
				// enter開閉
				item1.querySelector('button').addEventListener("keydown", function (event) {
					if(event.keyCode === 13) {
						if(!(event.currentTarget.nextElementSibling.classList.contains(a))) {
							event.currentTarget.nextElementSibling.classList.add(a);
						} else {
							event.currentTarget.nextElementSibling.classList.remove(a);
						}
						return false;
					}
				});
				// listからフォーカスが外れたとき
				item1.querySelector('button').addEventListener('blur', () => {
					item1.querySelector('.history-nav-in-list-item-list').classList.remove(a);
				})
				// listからフォーカスが外れた・当たったとき
				if(item1.querySelectorAll('.history-nav-in-list-item-list').length) {
					item1.querySelector('.history-nav-in-list-item-list').querySelectorAll('a').forEach(link => {
						link.addEventListener('blur', () => {
							item1.querySelector('.history-nav-in-list-item-list').classList.remove(a);
						})
						link.addEventListener('focus', () => {
							item1.querySelector('.history-nav-in-list-item-list').classList.add(a);
						})
					});
				}
			}
		});
		// sp 
		const spmenu = document.querySelector('.history-nav-in-menu-btn');
		const spmenuContents = document.querySelector('.history-nav-in-menu-contents');
		const spmenuClose = document.querySelector('.history-nav-in-menu-btn-close');
		spmenu.addEventListener('click', (e)=> {
			if(!(e.currentTarget.classList.contains(a))) {
				e.currentTarget.classList.add(a);
				spmenuContents.classList.add(a);
			} else {
				e.currentTarget.classList.remove(a);
				spmenuContents.classList.remove(a);
			}
		});
		spmenuClose.addEventListener('click', (e)=> {
			if(!(spmenu.classList.contains(a))) {
				spmenu.classList.add(a);
				spmenuContents.classList.add(a);
			} else {
				spmenu.classList.remove(a);
				spmenuContents.classList.remove(a);
			}
		});
		// グローバルヘッダーの言語切り替え設定
		// if(location.pathname.split('/')[1] == 'history') {
		// 	let setHref = '/history' + document.querySelector('.header-nav-sub-lang').querySelector('a').getAttribute('href');
		// 	let setHrefSp = '/history' + document.querySelector('.header-nav-sp-lang').querySelector('a').getAttribute('href');
		// 	document.querySelector('.header-nav-sub-lang').querySelector('a').setAttribute('href', setHref);
		// 	document.querySelector('.header-nav-sp-lang').querySelector('a').setAttribute('href', setHrefSp);
		// }
	};
	const historyslider = () => {
		if(document.querySelectorAll('.history-slider01').length) {
			const historyslider01 = new Swiper('.history-slider01', {
				spaceBetween: 0,
				loop: true,
				loopAdditionalSlides: 0,
				speed: 1000,
				slidesPerView: 1,
				centeredSlides: true,
				autoplay: {
					delay: 4000,
					disableOnInteraction: false,
				},
				breakpoints: {
				  1024: {
					slidesPerView: 1.72,
				  },
				},
				pagination: {
					el: '.history-slider01-control .swiper-pagination',
					clickable: true,
				}
			});
			document.querySelector('.history-slider01-control-button').addEventListener('click', (e) => {
				if(!(e.currentTarget.classList.contains(a))) {
					e.currentTarget.ariaLabel = '停止';
					e.currentTarget.classList.add(a);
					historyslider01.autoplay.start();
				} else {
					e.currentTarget.ariaLabel = '再生';
					e.currentTarget.classList.remove(a);
					historyslider01.autoplay.stop();
				}
			});
			setTimeout(() => {
				document.querySelector('.history-slider01').classList.remove('is-o0');
			}, 300);
		}
	};
	historyslider();
	if(document.querySelectorAll('.history-nav').length) {
		historynav();
	}

})(window.FUNCTIONS);
